export const globalSearchScrollContainerId = 'global-search-scroll-container';
export const QUERY_SEARCH_KEY = 'searchString';
export const QUERY_COLLAB_SEARCH_KEY = 'searchCollaborator';
export const SESSION_STORAGE_COLLABS_KEY = 'collabsDetailsList';
